import {getCookie} from "../../bundled_js/cookie_utils";
export default {
    computed: {
        baselinePhoenixChanges() {
            return this.isPhoenixCustomer || this.isPhoenixPhaseTwoCustomer || this.isPhoenixPhaseThreeCustomer;
        },
        phoenixExptChanges() {
            return this.isPhoenixPhaseTwoCustomer || this.isPhoenixPhaseThreeCustomer;
        }
    },
    methods: {
        getAnalyticsCookie() {
            let analyticsId = null;
            try{
                analyticsId = getCookie('ajs_anonymous_id');
            }
            catch(e) {
                console.error("analytics anonymous user identify error", e);
            }
            return analyticsId
        }
        
        
    }
}